module.exports = __webpack_public_path__ + "img/educabinh_name_background.7dab470e.png";